module.exports = __webpack_public_path__ + "img/george-calvert.a1e0e4d8.png";